import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { Dao } from '@app/dao/dao';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewDao extends Dao {
  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  searchNews(category): Observable<any> {
    return this.httpApi.get(`/product/${category}/news?size=10`);
  }

  allCategory(): Observable<any> {
    return this.httpApi.get('/ref/news/categories');
  }

  /* state */
  reset() {}

  onUserChange(event: any) {
    this?.reset();
  }
}
